export default {
    data() {
        return {

            /**
             * If you update the list remember to update ResearchDefenderService.php as well!
             */
            researchDefenderFailureCodes: [
                {
                    name: 'Duplicate entrant',
                    code: 2,
                    description: 'We have determined that the respondent has already participated via their IP Address or Digital Fingerprint'
                },
                {
                    name: 'User emulator',
                    code: 3,
                    description: 'Emulators basically emulate/recreate and can spoof other devices. One example is using the \'windows on windows\' tag where a respondent has multiple Operating System instances on their device. This allows a respondent to (appear to) have a completely unique digital fingerprint on a single device'
                },
                {
                    name: 'VPN usage',
                    code: 4,
                    description: 'A Virtual Private Network. There are many reasons to use a VPN. However, when a panelist is on a VPN, Public Proxy and is flagged as an Internet Fraudster, that has an extremely high correlation to fraudulent activity.'
                },
                {
                    name: 'TOR network',
                    code: 5,
                    description: 'TOR is a software used to enable anonymous communication in order to conceal a user’s location. Like Proxies and VPNs, TOR use alone does not indicate fraudulent activity, but combined with other flags it can be used to determine the likelihood of fraudulent behavior. This status indicates that this respondent is using or has been linked to a TOR Network'
                },
                {
                    name: 'Public proxy server',
                    code: 6,
                    description: 'A proxy acts as an intermediary between a respondent and a remote connection on the internet. The Public Proxy status indicates the respondent is accessing a survey using a publicly available proxy server. Public Proxies can be accessed by multiple respondents at the same time'
                },
                {
                    name: 'Web proxy',
                    code: 7,
                    description: 'Web Proxies are a subset of a Public Proxy, but can be accessed via the internet with no software or security'
                },
                {
                    name: 'Web crawler',
                    code: 8,
                    description: 'This indicates that a respondent has been linked to Web Crawling activity in the past, which has a high correlation to some fraudulent activity, specifically in the Ad Tech space.'
                },
                {
                    name: 'Internet fraudster',
                    code: 9,
                    description: 'These are respondents that have been linked to general fraud/abuse on the internet. These are flagged by one or more of the third party vendors we work with who compile databases of fraudsters from various sites on the internet.'
                },
                {
                    name: 'Retail fraudster',
                    code: 10,
                    description: 'These are respondents that have been linked to abuse specifically in the Retail or Ad-Tech industry.'
                },
                {
                    name: 'IP subnet',
                    code: 11,
                    description: 'A subnet is a recreation of the same IP address to spoof against technologies that are looking for a direct match, this can be done easily in order to make an IP Address seem unique. An example of a subnet is below (this is from the same survey) where someone has changed their device\'s IP Address by a single digit:'
                },
                {
                    name: 'Recent abuse',
                    code: 12,
                    description: 'The respondent has been recently flagged for fraud/abuse by one of our fraud prevention providers'
                },
                {
                    name: 'Automation tool',
                    code: 14,
                    description: 'Research Defender has detected any number of automation tools (Selenium, Puppeteer, Playwright) in the respondents browser or machine, these tools are synonymous with fraudulent activity in Market Research'
                },
                {
                    name: 'Developer tool',
                    code: 15,
                    description: 'Research Defender has detected a developer tool window that is open on the respondent’s browser, this is often used by fraudsters to manipulate API response data and/or their digital fingerprint'
                },
                {
                    name: 'Web RTC IP',
                    code: 16,
                    description: 'WebRTC is technology used to video conferences which leaks users real IP address. Disabled WebRTC is highly unusual settings and indicative of fraud.'
                },
            ]
        }
    },

    methods: {

        getRDFailureName(failureCode) {
            const item = this.findRDFailure(failureCode)
            return item ? item.name : null
        },
        getRDFailureDescription(failureCode) {
            const item = this.findRDFailure(failureCode);
            return item ? item.description : null
        },
        findRDFailure(failureCode) {
            return this.researchDefenderFailureCodes.find(item => item.code === parseInt(failureCode));
        }
    }
}

